import { useEffect, useRef } from 'react';

import { useAppleMapkitWebExperiment } from 'experiments/use-enable-apple-mapkit-web-experiment';
import { loadMapKitJSLibrary } from 'utils/apple-mapkit/index.web';
import { getConfigValue } from 'utils/environment';

export function useLoadAppleMapKit(): void {
  const { isReady, isTreatment } = useAppleMapkitWebExperiment();
  const enabledAppleMapkit = isReady && isTreatment;
  const { mapKitWebJSToken } = getConfigValue({ key: 'apple', defaultValue: {} });
  const hasSucceeded = useRef(false);

  useEffect(() => {
    if (!enabledAppleMapkit || !mapKitWebJSToken || hasSucceeded.current) {
      return;
    }
    loadMapKitJSLibrary(mapKitWebJSToken).then(() => {
      hasSucceeded.current = true;
    });
  }, [enabledAppleMapkit, mapKitWebJSToken]);
}
